import { render, staticRenderFns } from "./header-tip.vue?vue&type=template&id=9b567218&scoped=true&"
import script from "./header-tip.vue?vue&type=script&lang=js&"
export * from "./header-tip.vue?vue&type=script&lang=js&"
import style0 from "./header-tip.vue?vue&type=style&index=0&id=9b567218&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b567218",
  null
  
)

export default component.exports